import { supabase } from '../lib/supabase';

export type ClaimEntityType = 'production' | 'sample' | 'express_order' | 'express_sample';

export interface CreateClaimParams {
  entityType: ClaimEntityType;
  entityId: string;
  entityName: string;
  clientName?: string;
  salesperson: string;
  clientId?: string;
}

function generateToken(): string {
  return crypto.randomUUID().replace(/-/g, '').slice(0, 24);
}

export async function createClaim(params: CreateClaimParams): Promise<{ token: string; claimId: string } | null> {
  const token = generateToken();
  const { data, error } = await supabase
    .from('claims')
    .insert({
      token,
      entity_type: params.entityType,
      entity_id: params.entityId,
      entity_name: params.entityName,
      client_name: params.clientName || null,
      salesperson: params.salesperson,
      client_id: params.clientId || null,
      status: 'pending',
    })
    .select('id')
    .single();

  if (error) {
    console.error('Error creating claim:', error);
    return null;
  }
  return { token, claimId: data.id };
}

export function getClaimUrl(token: string): string {
  const base = typeof window !== 'undefined' ? window.location.origin : 'https://www.productex.app';
  return `${base}/reclamo/${token}`;
}

export function getClaimMessage(token: string): string {
  const link = `https://www.productex.app/reclamo/${token}`;
  return `Para poder entender bien lo ocurrido y ayudarte de la mejor manera, necesitamos que completes el formulario de reclamos con el detalle de la incidencia, es obligatorio completarlo.

Una vez enviado, el caso será analizado y te estaremos respondiendo dentro de las 96 horas hábiles, según nuestras condiciones comerciales.

Te dejamos el link para registrar el reclamo:
👉 ${link}

Gracias por la comprensión.`;
}

const CLAIM_BUCKET = 'claim-attachments';

export async function uploadClaimFile(token: string, file: File, type: 'photo' | 'video'): Promise<string | null> {
  const ext = file.name.split('.').pop() || 'jpg';
  const path = `claims/${token}/${type}/${crypto.randomUUID()}.${ext}`;
  const { data, error } = await supabase.storage.from(CLAIM_BUCKET).upload(path, file, {
    cacheControl: '3600',
    upsert: false,
  });
  if (error) {
    console.error('Error uploading claim file:', error);
    return null;
  }
  const { data: urlData } = supabase.storage.from(CLAIM_BUCKET).getPublicUrl(data.path);
  return urlData.publicUrl;
}
